import React, { useState } from 'react';

const HomePageFaq = () => {
  const faqItems = [
    {
      question: "What is a Recruiting Agency Association?",
      answer: "A Recruiting Agency Association is an organized body that brings together licensed recruitment and manpower agencies to promote ethical recruitment, improve industry standards, resolve common issues, and strengthen collaboration among members. It also acts as a unified voice representing the interests of recruitment agencies at national and international platforms."
    },
    {
      question: "What is AIRAA?",
      answer: "AIRAA (All India Recruiting Agencies Association) is a non-profit organization representing over 1,700 licensed recruiting agencies and 200+ skill development companies across India. AIRAA works to enhance ethical recruitment practices, support global workforce mobility, engage with government bodies, and provide a strong platform for knowledge sharing, industry collaboration, and policy advocacy."
    },
    {
      question: "How to Register with AIRAA?",
      answer: `
        You can register with AIRAA by completing the online membership form on the official website.         
        Steps to Register:
        •	Click on the AIRAA registration link. https://www.airaa.co.in/registration
        •	Complete the form with your agency’s details. 
        •	Upload required documents. 
        •	Submit the application 
        •	After Payment, you will receive your membership Membership Certificate

        Note: Membership is currently offered free of charge for the year 2026. The validity of this membership will be until March 2027. Post this period, membership will be subject to applicable fees as per AIRAA guidelines.
       `
    },
    {
      question: "How do I become an AIRAA member?",
      answer: `Joining AIRAA is simple. Any licensed recruiting agency or skill development company in India or any company  is eligible. Just submit your application through the registration link. After review and approval, your membership will be activated.
        Note: AIRAA is currently offering 1-year free membership, making it an excellent time to join.`
    },
    {
      question: "How to Join AIRAA?",
      answer: "Fill the registration form, submit your recruitment agency documents, and pay the membership fee. Our team verifies and approves within 7 working days."
    },
    {
      question: "What Are the Benefits of AIRAA Membership?",
      answer: `AIRAA provides several advantages to its members, including:
        Enhanced Credibility: Membership strengthens the reputation and trustworthiness of your agency. 
        Networking Opportunities: Connect with 1,700+ recruitment agencies and 200+ skill companies nationwide. 
        International Partnerships: Opportunities to collaborate with overseas employers, chambers, and global stakeholders. 
        Government Advocacy: AIRAA represents member interests with ministries and regulatory authorities. 
        Training & Capacity Building: Access to knowledge sessions, compliance workshops, and skilling initiatives. 
        Ethical Recruitment Support: Promote safe, responsible, and transparent recruitment practices. 
        Business Growth Opportunities: Access to new job leads, partnerships, and collaborations. 
        Industry Updates: Stay informed about the latest policies, regulations, and global demand trends.`
    },
    {
      question: "What is PDOT centre support and how does AIRAA help?",
      answer: "AIRAA assists member agencies in setting up and managing PDOT (Protector of Emigrants) centres. We provide documentation guidance, liaison with the Ministry of External Affairs, and ensure compliance with emigration regulations."
    },
    {
      question: "Does AIRAA offer skill verification for jobs in KSA (Saudi Arabia)?",
      answer: "Yes, AIRAA facilitates skill verification and KSA-specific certification programmes. We partner with government-approved training centres to assess and certify candidates, ensuring they meet Gulf country employer standards."
    },
    {
      question: "How can I report a fraudulent recruitment agency?",
      answer: "You can report fraudulent agencies directly through the AIRAA helpline (+91 7738355865) or via our website's complaint portal. We also share official MEA advisories and maintain a public list of unregistered agencies on our Fraud Alerts page."
    },
    {
      question: "What community initiatives does AIRAA run?",
      answer: "AIRAA organizes free medical camps, blood donation drives, cancer patient support programmes, and vocational training for underprivileged youth. These initiatives are part of our social responsibility to empower workers and local communities."
    },
    {
      question: "What are the benefits of joining AIRAA as a recruiting agency?",
      answer: "Members get MEA policy advocacy, PDOT centre support, skill verification services, legal guidance, access to global employer networks, training discounts, and representation in chambers like ASSOCHAM and Indo‑German Chamber of Commerce."
    }
  ];

  // State to track which FAQ item is open (by index)
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 px-6 md:px-12 lg:px-24 text-gray-900">
      <div className="md:container md:mx-auto">
        <h2 className="text-4xl font-extrabold text-center mb-8 text-blue-900">
          Frequently Asked <span className="text-green-600">Questions</span>
        </h2>
        <div
          itemScope
          itemType="https://schema.org/FAQPage"
          className="grid grid-cols-1 md:grid-cols-1 gap-6"
        >
          {faqItems.map((item, index) => (
            <div
              key={index}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className="bg-gray-50 rounded-xl shadow-md border-l-4 border-green-500 hover:shadow-lg transition-shadow duration-300 overflow-hidden"
            >
              {/* Question header - clickable */}
              <button
                onClick={() => toggleItem(index)}
                className="w-full text-left p-6 focus:outline-none flex justify-between items-center"
                aria-expanded={openIndex === index}
              >
                <h3
                  itemProp="name"
                  className="text-xl font-bold text-blue-800 pr-4"
                >
                  {item.question}
                </h3>
                {/* Chevron icon - rotates when open */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-5 w-5 text-green-600 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''
                    }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Answer - collapsible */}
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
                className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  } overflow-hidden`}
              >
                <div
                  itemProp="text"
                  className="text-gray-700 leading-relaxed px-6 pb-6 whitespace-pre-line"
                >
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomePageFaq;